import { IAccounts } from 'types/interfaces/accounts';

import { Account } from './Account';
import { Container } from './styles';

interface IProps {
  accounts: IAccounts[];
}

export const AccountList: React.FC<IProps> = ({ accounts }) => {
  return (
    <Container>
      {accounts.map(account => (
        <Account
          key={account.id}
          name={account.name}
          photo={account.photo}
          email={account.email}
          isMe={account.isMe}
          id={account.id}
        />
      ))}
    </Container>
  );
};
